import React, { useState, Fragment, useCallback, useEffect } from 'react';

const ProductPrice = ({ order }, hideDiscount) => {
  const productPrice = useCallback((order, hideDiscount) => {
    return (
      <Fragment>
        {order.campaignPrice ? (
          <Fragment>
            <div className="checkout-cart__campaign-price">
              {order.campaignPrice}
            </div>
            {!hideDiscount && (
              <div className="checkout-cart__original-price">
                {' '}
                ({order.price})
              </div>
            )}
          </Fragment>
        ) : (
          <div>{order.price}</div>
        )}
      </Fragment>
    );
  }, []);

  return productPrice(order, hideDiscount);
};
export default ProductPrice;
